import { ReactElement, ReactNode, useEffect, useRef, useState } from 'react';

/**
 * Renders its content with the width it has, for a table that splits its room
 * itself. A table cell clips its text only at a measure in pixels, so a column
 * that is to stop growing needs the width worked out from the table's own.
 */
export const PaloMeasure = ({ children }: { children: (width: number) => ReactNode }): ReactElement => {
    const ref = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const element = ref.current;

        if (!element) {
            return undefined;
        }

        const observer = new ResizeObserver(entries => setWidth(Math.round(entries[0]?.contentRect.width ?? 0)));
        observer.observe(element);

        return () => observer.disconnect();
    }, []);

    return <div ref={ref}>{children(width)}</div>;
};

/**
 * What a capped column leaves for the ones that take the rest, split evenly.
 * Zero until the table is measured or while it has no room to give.
 */
export const paloSurplus = (tableWidth: number, fixedWidth: number, cap: number, sharers: number): number =>
    Math.max(0, Math.floor((tableWidth - fixedWidth - cap) / sharers));
